<template>
    <div class="body">
        <div v-if="!showAutoDrop">
            <div class="f-row f-wrap">
                <c-input v-model="hideEliminated" :labelLeft="false" :title="$t('text.showEliminated')" type="checkbox" class="hide-checkbox" :outline="false" :dense="true"></c-input>
                <div class="top-button-row">
                    <c-button :label="$t('text.save')" @click="saveEdit"></c-button>
                    <c-button v-if="!isEditWith && this.ConnectionState" :label="$t('text.autodrop')" @click="showAutoDrop=true"></c-button>
                </div>
                <div class="break"></div>
                <div v-if="!isEditWith" class="try">
                    <div>{{$t('text.try')}}</div>
                    <!-- <c-select v-model="cResultId" :options="{value: 0, label: 'test'}"></c-select> -->
                    <select v-model="cResultId" :class="{error: isFirstTry}" @change="sortEntries">
                        <option v-for="(t, i) in SelectedHeat.entries[0].results.length" v-bind:key="i" :value="i">{{t}}</option>
                    </select>
                </div>
            </div>
            <div>                   
                <div class="header">
                    <div class="label-rank">
                        <div class="icon rank"></div>
                        <div class="icon bib"></div>
                    </div>
                    <div class="label-name">
                        <div>{{$t('text.name')}}</div>
                        <div>{{$t('text.class')}}</div>
                    </div>                        
                    <div class="label-result">
                        <div>{{$t('text.result')}}</div>
                    </div>  
                    <div class="label-controll"></div>
                    <div class="label-controll"></div>
                    <div class="label-controll"></div>
                </div>
                <template v-for="i in 2">
                    <div class="content" v-for="(entrant, eId) in getSortedEntries(i===1)" :key="entrant.id" :class="{zebra: eId%2==0, hide: (i===2 && isEliminatedHidden), disabled: i===2}">
                        <div class="label-rank">
                            <div>{{getRank(entrant.rank)}}</div>
                            <div>{{entrant.bib}}</div>
                        </div>
                        <div class="label-name">
                            <div>{{entrant.name}}</div>
                            <div>{{entrant.classShort}}</div>
                        </div>                        
                        <div class="label-result">
                            <div>{{getBestResult(entrant)}}</div>
                        </div>  
                        <div class="label-controll">
                            <c-input v-if="i===1" v-model="dropTable[entrant.id]" @change="setNewDrop(entrant.id)" :displayLabel="false" :dense="true" :outline="false" type="checkbox" :disabled="isFirstTry"></c-input>
                        </div>
                        <div class="label-controll"><span @click="setDropUp(entrant)" v-if="showUpArrow(eId) && i===1 && dropTable[entrant.id]" class="icon up" :class="{disabled: isFirstTry}"></span></div>
                        <div class="label-controll"><span @click="setDropDown(entrant)" v-if="showDownArrow(eId) && i===1 && dropTable[entrant.id]" class="icon down" :class="{disabled: isFirstTry}"></span></div>
                    </div>
                </template>
            </div>
        </div>
        <div v-if="(isEditWith || showAutoDrop)" class="auto-drop">
            <div>
                <div class="try">                    
                    <c-button v-if="!isEditWith" :label="$t('text.listView')" @click="showAutoDrop=false" class="b-list-view"></c-button>
                    <div>{{$t('text.try')}}</div>
                    <!-- <c-select v-model="cResultId" :options="{value: 0, label: 'test'}"></c-select> -->
                    <select v-model="cResultId" :class="{error: isFirstTry}" @change="sortEntries">
                        <option v-for="(t, i) in SelectedHeat.entries[0].results.length" v-bind:key="i" :value="i">{{t}}</option>
                    </select>
                    <span v-if="isFirstTry" class="error">{{$t('text.errorFirstTryDrop')}}</span>
                </div>
                <div>
                    <div>{{$t('text.ranking')}}</div>
                    <c-input v-model="rankings" :displayLabel="false" type="number"></c-input>
                </div>
                <div>
                    <c-input v-model="difClasses" :title="$t('text.seperateClasses')" :labelLeft="false" labelWidth="100%" type="checkbox"></c-input>
                </div>
                <div>
                    <c-button :label="$t('text.drop')" @click="dropStartList(0)" :disabled="isFirstTry || ConnectionState === 0"></c-button>
                </div>
                <div>
                    <c-button :label="$t('text.dropAfterN', {n: rankings})" @click="dropStartList(1)" :disabled="isFirstTry || ConnectionState === 0"></c-button>
                </div>
                <div>
                    <c-button :label="$t('text.reset')" @click="dropStartList(2)" :disabled="isFirstTry || ConnectionState === 0"></c-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';
import navMut from '../store/mutations/navigation';

import CButton from './CButton';
import CInput from './CInput';
// import CSelect from './CSelect';

export default {
    name: "DropStartlist",
    data: function(){
        return {
            request: (data) => {
                //console.log(data)
                if(data.id === this.SelectedHeat.id) {
                    this.SETDROPEDENTRANTS(data.entries);
                    this.sortEntries();
                }
            },
            window: {
                width: 0,
                height: 0,
            },
            dropTable: [],
            autoMode: true,
            cResultId: null,
            rankings: 8,
            difClasses: false,
            hideEliminated: false,
            okEntries: [],
            noEntries: [],
            showAutoDrop: false,
        }
    },
    methods:{
        ...mapActions([
            glAct.AUTODROP,
            glAct.SENDHEATGROUP
            ]),
        ...mapMutations([
            navMut.SHOWNAVPOINT,
            navMut.HIDENAVPOINT
            ]),
        ...mapMutations([
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB,
            glMut.SETDROPEDENTRANTS,
            ]),
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
            if(this.window.width >= 640){
                this.showAutoDrop = false;
            }
        },
        getBestResult(e){
            if(e.bestResultId){
                const r = e.results.filter(x => x.id == e.bestResultId)[0];
                return (r && r.value) ? r.value.toFixed(2) : '';
            }
            return '';
        },
        getRank(r){
            return !r ? '-' : `${r}.`;
        },
        saveEdit(){
            this.SENDHEATGROUP();
            if (!this.$route.path.includes('/startlist'))
                this.$router.push('/competition/events/event/startlist');
        },
        dropStartList(dropType){
            if(this.cResultId !== 0){
                const drop = {
                    HeatGuid: this.SelectedHeat.id,
                    Try: this.cResultId,
                    Places: Number.parseInt(this.rankings, 10),
                    SplitClasses: this.difClasses,
                    DropActionType: dropType
                };

                this.AUTODROP(drop);

                this.showAutoDrop = false;
            }
        },
        isEliminated(e){
            if(!e.isEnabled)
                return true;

            const oA = [];
            e.results.slice(0, this.cResultId).forEach(x => {
                oA.push(x.highjumpTries);
            });
            return oA.includes('r');
        },
        showUpArrow(i){
            return i !== 0;
        },
        showDownArrow(i){
            return this.okEntries.filter(e => e.dropStartlist[this.cResultId]).length-1 !== i;
        },
        setNewDrop(id){
            const entrie = this.SelectedHeat.entries.find(e => e.id === id);
            if(this.dropTable[id]){
                if(entrie.dropStartlist[this.cResultId] == undefined) {
                    entrie.dropStartlist[this.cResultId] = this.SelectedHeat.entries.filter(e => e.dropStartlist[this.cResultId] != undefined).length+1;
                }
            }
            else{
                var oldVal = entrie.dropStartlist[this.cResultId];
                entrie.dropStartlist[this.cResultId] = undefined;
                let obj = {};
                for(var i=0; i<= 5; i++){
                    if(!!entrie.dropStartlist[i])
                        obj[i.toString()] = entrie.dropStartlist[i];
                }
                entrie.dropStartlist = obj;
                
                this.SelectedHeat.entries.filter(e => e.dropStartlist[this.cResultId] != undefined).forEach(e => {
                    if(e.dropStartlist[this.cResultId] > oldVal)
                        e.dropStartlist[this.cResultId]--
                });
            }
            this.sortEntries();
            
        },
        setDropDown(entrant){
            const entries = this.SelectedHeat.entries;
            const pos = entrant.dropStartlist[this.cResultId];
            const preEntrie = entries.find(e => e.dropStartlist[this.cResultId] === pos+1)
            preEntrie.dropStartlist[this.cResultId] = pos;
            this.SelectedHeat.entries.find(e => e.id===entrant.id).dropStartlist[this.cResultId] = pos+1;
            this.sortEntries();

        },
        setDropUp(entrant){
            const entries = this.SelectedHeat.entries;
            const pos = entrant.dropStartlist[this.cResultId];
            const preEntrie = entries.find(e => e.dropStartlist[this.cResultId] === pos-1)
            preEntrie.dropStartlist[this.cResultId] = pos;
            this.SelectedHeat.entries.find(e => e.id===entrant.id).dropStartlist[this.cResultId] = pos-1;
            this.sortEntries();
        },
        sortEntries(){
            this.okEntries = [];
            this.noEntries = [];

            var tries = this.SelectedHeat.entries[0].results.length - 1;
            let nextDrop = 0;
            let oldDrop = 0;

            this.SelectedHeat.entries.forEach(e => {

                this.dropTable[e.id] = !!e.dropStartlist[this.cResultId];
                
                for(var i=0; i<=this.cResultId; i++){
                    if(e.dropStartlist[i] !== undefined && i > nextDrop) {
                        oldDrop = nextDrop;
                        nextDrop = i;
                    }
                }
                
                if(!e.isEnabled || this.isEliminated(e)) {
                    this.noEntries.push(e);
                }
                else{
                    this.okEntries.push(e);
                }
            });

            if(nextDrop < this.cResultId) {
                this.noEntries = this.noEntries.concat(this.okEntries.filter(e => !e.dropStartlist[nextDrop]));
                this.okEntries = this.okEntries.filter(e => !!e.dropStartlist[nextDrop])
            }
            else if(nextDrop == this.cResultId){               
                this.noEntries = this.noEntries.concat(this.okEntries.filter(e => !e.dropStartlist[oldDrop]));
                this.okEntries = this.okEntries.filter(e => !!e.dropStartlist[oldDrop])
            }

            this.okEntries = this.okEntries.sort((a, b) => {
                if(a.dropStartlist[nextDrop] && b.dropStartlist[nextDrop]) {
                    if (a.dropStartlist[nextDrop] < b.dropStartlist[nextDrop]) return -1;
                    if (a.dropStartlist[nextDrop] > b.dropStartlist[nextDrop]) return 1;
                    return 0;
                }
                if(a.dropStartlist[nextDrop] && !b.dropStartlist[nextDrop]) {
                    return -1;
                }
                if(!a.dropStartlist[nextDrop] && b.dropStartlist[nextDrop]) {
                    return 1;
                }
                
                if (a.dropStartlist[0] < b.dropStartlist[0]) return -1;
                if (a.dropStartlist[0] > b.dropStartlist[0]) return 1;
                return 0;
            })

            this.noEntries = this.noEntries.sort((a, b) => {
                if (a.dropStartlist[0] < b.dropStartlist[0]) return -1;
                if (a.dropStartlist[0] > b.dropStartlist[0]) return 1;
                return 0
            })
        },
        getSortedEntries(validEntries){            
            if(validEntries)
                return this.okEntries;

            return this.noEntries;
        },
    },
    computed:{
        ...mapGetters(['SelectedHeat', 'ConnectionState', 'CResultId']),        
        getWindowWidth(){
            return this.window.width;
        },
        isEditWith(){
            return this.getWindowWidth >= 640;
        },
        isFirstTry(){
            return this.cResultId === 0;
        },
        isEliminatedHidden(){
            return !this.hideEliminated;
        }
    },
    components: {
        CButton,
        CInput,
        // CSelect,
    },
    mounted(){  
        this.cResultId = this.CResultId;
        window.addEventListener('resize', this.handleResize);
        this.sortEntries();
        this.handleResize();    
        this.SHOWNAVPOINT([1,2]);
    },   
    created(){
        var RegisterMethods = () => {
            this.REGISTERHUB({
                name: "SendHeatDetails",
                method: this.request
            });
        }

        if(this.Connection != ""){
            RegisterMethods();
        }

        this.$store.subscribe((mutation, state) => {
            if(mutation.type == glMut.SETCONNECTION && state.glModule.connection != ""){
                RegisterMethods();
            }
        });
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.handleResize);    
        this.HIDENAVPOINT([1,2]);
        this.UNREGISTERHUB({
                name: "SendHeatDetails",
                method: this.request
        });
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";    

    .body {
        @extend %f-row;
                
        .error {
            color:$prim_aleart_color;
            border-color:$prim_aleart_color;            
            font-size: 10px;
        }

        .disabled {
            opacity: 0.5;
        }

        .hide {
            display:none!important;
        } 
        
        .break {
            flex-basis: 100%;
        }

        .try {
            @extend %f-column;
            flex-grow: 0;
            padding-top:10px;
            width:100%;
            padding-bottom: 10px;

            select {
                color: $font-light-color;
                height: $height_default;
                width:100%;
                background-color: $prim_bg_color;
                font-size: 20px;
            }
        }

        .icon {
            font: normal normal normal 24px/1 "Material Design Icons";
            line-height: 14px;
        }

        > div { // basically grid body and auto-drop
            @extend %f-grow;
            @extend %f-column;

            padding: 10px;

            .hide-checkbox {
                margin-right: auto;
            }

            .top-button-row > * {
                margin-bottom:10px;
                margin-left:10px;
            }

            .content, .header {
                @extend %f-row;
                @extend %f-grow;

                font-size: 14px;
                line-height: 14px;
                font-weight: bold;
                height: $height_default;
                max-height: $height_default;
                align-items: center;

                > div { // each column
                    @extend %f-column;

                    > div {
                        display: flex;
                        justify-content: center;
                    }
                    > div:nth-of-type(2){
                        font-size: 10px;
                    }
                }

                //labels for header and content-rows
                .label-rank {
                    width: 20px;
                    min-width: 20px;
                }

                .label-name {
                    @extend %f-grow;
                    align-items: baseline;
                }

                .label-result {
                    width:80px;
                    min-width: 80px;
                }

                .label-controll {
                    width: 30px;
                    min-width: 30px;
                    color: $seltec-color;
                    align-items: center;

                    .up::after {
                        content: "\F0737";
                        cursor: pointer;
                    }
                    .down::after {
                        content: "\F072E";
                        cursor: pointer;
                    }
                }
            }

            .header {
                background-color: $table-head-color;
                color: $seltec_color;

                .rank::after {
                    font-size: 14px;
                    content:"\F0987";
                }

                .bib::after {
                    font-size: 10px;
                    content:"\F0631";
                }
            }

            .content {
                background-color: $zebra-dark;
                color: $font-light-color;  
            }

            .content.zebra {
                background-color: $zebra-light;
                color: $font-light-color;
            }
        }

        @media screen and (max-width: 639px) {       
            .auto-drop {
                width:100%;
            }
        }

        .auto-drop {
            padding-left:0px;
            flex-grow: 0;
            min-width: $b_xs;

            .b-list-view {
                margin-bottom: 10px;
            }

            > div {
                @extend %f-column;
                background-color: $form-bg-color;
                padding:10px;

                > div:first-of-type {
                    padding-top:0px;
                }

                > div {
                    @extend %f-column;
                    flex-grow: 0;
                    padding-top:10px;
                }
            }
        }
    }

</style>